import { Link } from "react-router-dom";
import { SiteFooter, SiteHeader } from "@/components/SiteChrome";

export const Section = ({ title, id, children }) => (
  <section id={id} className="mt-8 scroll-mt-24">
    <h2 className="font-display text-xl font-bold text-white">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-zinc-400">{children}</div>
  </section>
);

export const PageShell = ({ kicker, title, lead, children }) => (
  <div className="min-h-screen text-white">
    <SiteHeader />
    <article className="mx-auto max-w-3xl px-5 py-16">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#A855F7]">{kicker}</p>
      <h1 className="mt-3 font-display text-4xl font-black tracking-tighter sm:text-5xl">{title}</h1>
      {lead && <p className="mt-4 text-base text-zinc-400">{lead}</p>}
      <div className="mt-2 text-xs text-zinc-600">
        Last updated:{" "}
        {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}
      </div>
      <div className="mt-8 border-t border-zinc-900 pt-4">{children}</div>
      <div className="mt-12 rounded-xl border border-zinc-900 bg-zinc-950 p-4 text-xs text-zinc-500">
        Questions? Email{" "}
        <a href="mailto:info@noobsync.com" className="text-[#A855F7]">info@noobsync.com</a>.
        Other policies:{" "}
        <Link to="/privacy" className="text-[#A855F7]">Privacy</Link> ·{" "}
        <Link to="/terms" className="text-[#A855F7]">Terms</Link> ·{" "}
        <Link to="/guidelines" className="text-[#A855F7]">Guidelines</Link>
      </div>
    </article>
    <SiteFooter />
  </div>
);
